var $a67524a79ccbe190$exports = {};
$a67524a79ccbe190$exports = {
  "alpha": "Alfa",
  "black": "nero",
  "blue": "Blu",
  "blue purple": "blu viola",
  "brightness": "Luminosit\xE0",
  "brown": "marrone",
  "brown yellow": "giallo bruno",
  "colorName": function colorName(args) {
    return "".concat(args.hue, " ").concat(args.chroma, " ").concat(args.lightness);
  },
  "cyan": "ciano",
  "cyan blue": "blu ciano",
  "dark": "scuro",
  "gray": "grigio",
  "grayish": "grigiastro",
  "green": "Verde",
  "green cyan": "verde ciano",
  "hue": "Tonalit\xE0",
  "light": "chiaro",
  "lightness": "Luminosit\xE0",
  "magenta": "magenta",
  "magenta pink": "rosa magenta",
  "orange": "arancio",
  "orange yellow": "giallo arancio",
  "pale": "tenue",
  "pink": "rosa",
  "pink red": "rosa rosso",
  "purple": "viola",
  "purple magenta": "viola magenta",
  "red": "Rosso",
  "red orange": "rosso arancio",
  "saturation": "Saturazione",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.hue, " ").concat(args.chroma, " ").concat(args.lightness, ", trasparenza ").concat(args.percentTransparent);
  },
  "very dark": "molto scuro",
  "very light": "molto chiaro",
  "vibrant": "vivace",
  "white": "bianco",
  "yellow": "giallo",
  "yellow green": "giallo verde"
};
export { $a67524a79ccbe190$exports as default };